import { createTheme } from '@one-thd/sui-atomic-components';

const THDOrangeTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand-500'
    }
  }
});

export { THDOrangeTheme };